import { assign } from 'xstate';
import { EstimatedSpendContext } from './estimatedSpendMachine';
import { EstimatedSpendMachineEvents } from './types/events';

/**
 * Assigns the estimated spend to the context
 */
export const assignEstimatedSpend = assign<
  EstimatedSpendContext,
  EstimatedSpendMachineEvents,
  EstimatedSpendContext,
  EstimatedSpendMachineEvents,
  never
>({
  estimatedSpend: (_, event) => {
    return event.estimatedSpend;
  },
});
